/**
 * Utility to generate a image srcset
 * @param {String}          templateUrl             img url template
 * @param {Object}          instructions
 * @param {String}          instructions.ratio      img ratio
 * @param {Array.<String>}  instructions.widths     collection of widths
 * @returns {String}    srcset
 */
const getSrcset = (templateUrl, instructions) => {

    const { ratio, widths } = instructions;
    const template = templateUrl.replace('{ratio}', ratio);

    return widths.map((width) => `${template.replace('{width}', width)} ${width}w`).join(', ');

};

export default getSrcset;
